import React, { useState } from "react";
import { View, Alert, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../components/text/DefaultText";
import DefaultTextBold from "../../components/text/DefaultTextBold";
import { MaterialIcons } from "@expo/vector-icons";
import * as deviceActions from "../../store/actions/device";
import SelectionItem from "../../components/SelectionItem";

const DeviceSettingScreen = (props) => {
  const dispatch = useDispatch();
  const { deviceId } = props.route.params;
  const socket = useSelector((state) => state.socket.io);
  const orientations = ["Landscape", "Portrait+", "Portrait-"];
  const backgroundColors = ["black", "white", "gray", "brown", "red"];
  const resizeModes = ["contain", "cover", "stretch"];

  const [selectedItem, setSelectedItem] = useState({
    orientation: "Landscape",
    backgroundColor: "black",
    resizeMode: "contain",
  });

  const selectItemHandler = (config, value) => {
    setSelectedItem({ ...selectedItem, [config]: value });
    console.log("selectItemHandler:", config);
    console.log("selectedItem:", selectedItem);
    if (config == "orientation") {
      value = value == "Landscape" ? "0" : value == "Portrait+" ? "90" : "270";
    }
    dispatch(
      deviceActions.updateDeviceSetting(deviceId, config, value, socket)
    );
  };
  // let TouchableCmp = TouchableOpacity;
  // if (Platform.OS === "android" && Platform.Version >= 21) {
  //   TouchableCmp = TouchableNativeFeedback;
  // }
  return (
    <View style={styles.screen}>
      <View style={styles.firstRow}>
        <DefaultTextBold>Orientation</DefaultTextBold>
      </View>
      <View style={styles.hline} />
      <SelectionItem
        config={"orientation"}
        items={orientations}
        onPressHandler={selectItemHandler}
        selectedItem={selectedItem["orientation"]}
        buttonStyle={{ margin: 8, marginBottom: 15 }}
      />
      <View style={styles.firstRow}>
        <DefaultTextBold>Background Color</DefaultTextBold>
      </View>
      <View style={styles.hline} />
      <SelectionItem
        config={"backgroundColor"}
        items={backgroundColors}
        onPressHandler={selectItemHandler}
        selectedItem={selectedItem["backgroundColor"]}
        buttonStyle={{ margin: 8, marginBottom: 15 }}
      />
      <View style={styles.firstRow}>
        <DefaultTextBold>Resize Mode</DefaultTextBold>
      </View>
      <View style={styles.hline} />

      <SelectionItem
        config={"resizeMode"}
        items={resizeModes}
        onPressHandler={selectItemHandler}
        selectedItem={selectedItem["resizeMode"]}
        buttonStyle={{ margin: 8, marginBottom: 15 }}
      />
      <View style={styles.firstRow}>
        <DefaultTextBold>Firmware Version</DefaultTextBold>
      </View>
      <View style={styles.hline} />
      <View style={styles.textSection}>
        <DefaultText>V1.0.0</DefaultText>
        <TouchableOpacity
          onPress={() => {
            Alert.alert("Proceed?", "Please do not turn off power", [
              { text: "No", style: "default" },
              {
                text: "Yes",
                style: "destructive",
                onPress: () => {
                  dispatch(
                    deviceActions.updateDeviceSetting(
                      deviceId,
                      "forceUpdate",
                      "true",
                      socket
                    )
                  );
                  dispatch(
                    deviceActions.updateDeviceSetting(
                      deviceId,
                      "apkLink",
                      "https://authentik-silo.web.app/assets/v1.0.2-0110.apk",
                      socket
                    )
                  );
                },
              },
            ]);
          }}
        >
          <MaterialIcons name="update" size={20} color="white" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
    margin: 16,
  },
  textContainer: {
    padding: 5,
  },
  buttonContainer: {
    // margin: 20,
    // height: 48,
    margin: 8,
  },
  firstRow: {},
  speedContainer: {
    flexDirection: "row",
    alignItems: "center",
    // justifyContent: "space-around",
    marginVertical: 8,
  },
  speedTextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderWidth: 1,
    borderColor: "white",
    padding: 8,
  },

  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    width: "100%",
    marginVertical: 8,
  },
  textSection: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export default DeviceSettingScreen;
